export default "__VITE_ASSET__B7ViBHQ3__"